import type { CustomError } from "@services/services.types";

import type { Actions } from "./apiEcms.types";

export const ADVANCED_REQUESTS: readonly Actions[] = [
  "POTENCY_COST",
  "CANCELLATION",
];

export const STANDARD_REQUESTS: readonly Actions[] = [
  "SHIFT_METER",
  "CONTESTATION",
  "TEMPORARY_METER",
  "OUT_OF_ORDER",
  "SPLIT_NETWORK",
  "DOOR_CHANGE",
  "OTHERS",
];

export const ERROR_CATEGORIES = {
  CHANGE_INITIAL_PASSWORD: "CHANGE_INITIAL_PASSWORD",
  UNAUTHORIZED: "UNAUTHORIZED",
  INVALID_CURRENT_PASSWORD: "INVALID_CURRENT_PASSWORD",
  INDEX_TOO_LOW: "INDEX_TOO_LOW",
  INDEX_TOO_HIGH: "INDEX_TOO_HIGH",
};

export const CUSTOM_ERRORS: Record<string, CustomError> = {
  INVALID_DATA: {
    type: "INVALID_DATA",
    message: "Invalid data",
    status: 601,
  },
  UNSPECIFIED_ERROR: {
    type: "UNSPECIFIED_ERROR",
    message: "Unspecified error",
    status: 600,
  },
} as const;
